import Notifications from 'react-notification-system-redux';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { getRequestErrorMessage } from '../../utilities/SagasHelper';
import * as api from '../../utilities/ServiceManager';
import {
  setCommonAiAdminFeedbackTemplates,
  setLoading,
  setSettings,
} from './actions';
import {
  GET_COMMON_AI_ADMIN_FEEDBACK_TEMPLATES,
  LOAD_SETTINGS,
  UPDATE_KEY,
} from './actionTypesSagas';

/**
 *  LOAD SETTINGS
 */
function* loadSettingsSaga() {
  yield takeLatest(LOAD_SETTINGS, loadSettings);
}

function* loadSettings(action) {
  try {
    yield put(setLoading(true));
    const settings = yield call(api.getSettings);
    yield put(setSettings(settings));
  } catch (exception) {
    yield put(setLoading(false));
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not load settings. Please try again later.',
      ),
    );
  } finally {
    yield put(setLoading(false));
  }
}

/**
 *  UPDATE KEY
 */
function* updateKeySaga() {
  yield takeLatest(UPDATE_KEY, updateKey);
}

function* updateKey(action) {
  try {
    yield call(api.updateKey, action.key);
    yield put(
      Notifications.show(
        {
          title: 'Done!',
          message: 'Setting updated successfully!',
          autoDismiss: 1,
        },
        'success',
      ),
    );
  } catch (exception) {
    yield put(
      showNotificationErrorFromException(
        exception,
        'Could not update setting. Please try again later.',
      ),
    );
  } finally {
  }
}

/** **************************************************************************
 * GET AI ADMIN FEEDBACK TEMPLATES
 */
function* getCommonAiAdminFeedbackTemplatesSaga() {
  yield takeLatest(
    GET_COMMON_AI_ADMIN_FEEDBACK_TEMPLATES,
    getCommonAiAdminFeedbackTemplates,
  );
}

function* getCommonAiAdminFeedbackTemplates() {
  try {
    const result = yield call(api.getCommonAiAdminFeedbackTemplates);
    yield put(setCommonAiAdminFeedbackTemplates(result));
  } catch (exception) {
    showNotificationErrorFromException(
      exception,
      'Could not get user custom prompt. Please try again later.',
    );
  }
}

/**
 * DEFAULT EXPORT
 */
export default function* sagas() {
  yield all([
    loadSettingsSaga(),
    updateKeySaga(),
    getCommonAiAdminFeedbackTemplatesSaga(),
  ]);
}

function showNotificationErrorFromException(exception) {
  const message = getRequestErrorMessage(exception);

  return Notifications.show({ title: 'Ops!', message }, 'error');
}
